/* Josenart 2.0 — 集合页（归属 B / B4）。
   <jn-collection>：筛选表单变化 / 排序 / 分页 / 移除筹码 → Section Rendering API（?section_id=）局部刷新
   [data-collection-bar] [data-collection-filters] [data-collection-results]，同步 pushState；popstate 回放。
   筛选抽屉 <dialog>：2026-09-07 Jack 要求去掉桌面左侧栏后，桌面和移动端共用同一个抽屉，
   由工具条上的 Filter 按钮打开（别再按视口宽度拦，桌面拦住了按钮就是死的）。无 JS 时表单 GET 照常。 */
(function () {
  if (customElements.get('jn-collection')) return;

  var MQ_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CLOSE_MS = 420;
  /* #39：局部刷新失败先退避重试一次，再不行才考虑整页跳 */
  var RETRY_MS = 800;
  var SCROLL_KEY = 'jnCollectionScroll';

  class JnCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.url || location.pathname;
      this.dialog = this.querySelector('.jn-filters');
      this.errorBox = this.querySelector('[data-filters-error]');
      this.abort = null;
      this.timer = null;
      this.lastRequest = null;
      this.bind();
      this.restoreScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._onPop);
    }

    bind() {
      var self = this;

      // 表单：checkbox / 排序即时生效；价格输入失焦后生效
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.form || t.form.id !== 'JnFilterForm') return;
        if (t.type === 'number') { self.schedule(400); return; }
        self.schedule(60);
      });
      this.addEventListener('submit', function (e) {
        var form = e.target;
        if (form.id !== 'JnFilterForm') return;
        e.preventDefault();
        self.apply();
        self.closeFilters();
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.type === 'number' && e.target.form && e.target.form.id === 'JnFilterForm') {
          e.preventDefault();
          self.apply();
        }
      });

      // 移除筹码 / 清除 / 分页：站内链接改局部刷新
      this.addEventListener('click', function (e) {
        var a = e.target.closest('a[data-filter-remove], .jn-pagination a');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        self.load(a.href, { scroll: !!a.closest('.jn-pagination') });
      });

      // 抽屉
      var openBtn = this.querySelector('[data-filters-open]');
      if (openBtn) openBtn.addEventListener('click', function () { self.openFilters(); });
      this.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeFilters(); }); });
      if (this.dialog) {
        this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.closeFilters(); });
        this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.closeFilters(); });
      }

      // #39：兜底提示里的「Try again」重放上一次失败的请求（不能用 apply() 重算，
      // 失败的可能是移除筹码那种 URL 操作，表单状态还没跟着变）
      var retryBtn = this.querySelector('[data-filters-retry]');
      if (retryBtn) {
        retryBtn.addEventListener('click', function () {
          if (self.lastRequest) self.load(self.lastRequest.url, self.lastRequest.opts);
        });
      }

      this._onPop = function () { self.load(location.href, { push: false }); };
      window.addEventListener('popstate', this._onPop);
    }

    schedule(ms) {
      var self = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { self.apply(); }, ms);
    }

    /* 表单 → URL（只带有值的字段） */
    formUrl() {
      var form = this.querySelector('#JnFilterForm');
      var params = new URLSearchParams();
      if (form) {
        var defaultSort = this.dataset.defaultSort;
        new FormData(form).forEach(function (value, name) {
          if (value === '' || value === null) return;
          if (name === 'sort_by' && value === defaultSort) return; // 默认排序不进 URL
          params.append(name, value);
        });
      } else {
        var sort = this.querySelector('[data-collection-sort]');
        if (sort && sort.value) params.set('sort_by', sort.value);
      }
      var qs = params.toString();
      return this.baseUrl + (qs ? '?' + qs : '');
    }

    apply() {
      this.load(this.formUrl(), { scroll: false });
    }

    load(url, opts) {
      var self = this;
      opts = opts || {};
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      var signal = this.abort.signal;
      this.lastRequest = { url: url, opts: opts };
      this.showError(false);
      this.setAttribute('aria-busy', 'true');
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', this.sectionId);

      var attempt = function (retriesLeft) {
        return fetch(u.toString(), { signal: signal })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .catch(function (err) {
            if (signal.aborted || (err && err.name === 'AbortError')) throw err;
            if (retriesLeft <= 0) throw err;
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                if (signal.aborted) {
                  var abortErr = new Error('aborted');
                  abortErr.name = 'AbortError';
                  reject(abortErr);
                  return;
                }
                resolve(attempt(retriesLeft - 1));
              }, RETRY_MS);
            });
          });
      };

      attempt(1)
        .then(function (html) {
          if (signal.aborted) return;
          self.render(html);
          if (opts.push !== false) history.pushState({ jnCollection: true }, '', url);
          if (opts.scroll) {
            var top = self.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: top, behavior: MQ_REDUCED.matches ? 'auto' : 'smooth' });
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          // #39：重试也失败了。抽屉开着就地报错——滚动位置和已勾的筛选都留着，
          // 客户可以点「Try again」；抽屉没开（分页 / 提交后已关）才退回整页跳，
          // 跳之前把滚动位置存起来，落地后恢复，不让客户回到顶部重新滚。
          if (self.dialog && self.dialog.open && self.errorBox) {
            self.showError(true);
            return;
          }
          self.rememberScroll(url);
          location.href = url;
        })
        .finally(function () {
          // 只有还是"当前那个请求"才解除忙碌态，否则会把后一个在飞的请求的遮罩擦掉
          if (self.abort && self.abort.signal === signal) self.setAttribute('aria-busy', 'false');
        });
    }

    showError(on) {
      if (this.errorBox) this.errorBox.hidden = !on;
    }

    rememberScroll(url) {
      try {
        sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
          url: new URL(url, location.origin).href,
          y: window.scrollY,
          t: Date.now()
        }));
      } catch (err) { /* 隐私模式 / 存储满，忽略即可 */ }
    }

    restoreScroll() {
      var saved;
      try {
        var raw = sessionStorage.getItem(SCROLL_KEY);
        if (!raw) return;
        sessionStorage.removeItem(SCROLL_KEY);
        saved = JSON.parse(raw);
      } catch (err) { return; }
      if (!saved || saved.url !== location.href) return;
      if (!saved.y || Date.now() - saved.t > 60000) return;
      var y = saved.y;
      var go = function () { window.scrollTo(0, y); };
      requestAnimationFrame(go);
      setTimeout(go, 250);
    }

    render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('[data-collection-results]')) throw new Error('Missing collection results');
      var active = document.activeElement;
      var focusKey = active && active.form && active.form.id === 'JnFilterForm' ? { name: active.name, value: active.value, type: active.type } : null;

      ['[data-collection-bar]', '[data-collection-filters]', '[data-collection-results]', '[data-collection-desc]'].forEach(function (sel) {
        var target = this.querySelector(sel);
        var source = doc.querySelector(sel);
        if (target && source) {
          if (sel === '[data-collection-bar]') {
            // 排序 select 保留焦点：只换文字与计数，不换整块
            var tCount = target.querySelector('.jn-collection__count');
            var sCount = source.querySelector('.jn-collection__count');
            if (tCount && sCount) tCount.textContent = sCount.textContent;
            var tBtn = target.querySelector('[data-filters-open]');
            var sBtn = source.querySelector('[data-filters-open]');
            if (tBtn && sBtn) tBtn.innerHTML = sBtn.innerHTML;
          } else {
            target.innerHTML = source.innerHTML;
          }
        }
      }, this);

      var applyBtn = this.querySelector('[data-filters-apply]');
      var srcApply = doc.querySelector('[data-filters-apply]');
      if (applyBtn && srcApply) applyBtn.textContent = srcApply.textContent;

      // 焦点回到刚操作的控件
      if (focusKey && focusKey.name) {
        var form = this.querySelector('#JnFilterForm');
        var el = null;
        if (form) {
          Array.prototype.some.call(form.elements, function (c) {
            if (c.name === focusKey.name && (focusKey.type === 'number' || c.value === focusKey.value)) { el = c; return true; }
            return false;
          });
        }
        if (el) el.focus({ preventScroll: true });
      }
    }

    /* ---------- 筛选抽屉（桌面 + 移动端同一个） ---------- */
    openFilters() {
      var d = this.dialog;
      if (!d || d.open) return;
      try { d.showModal(); } catch (err) { d.setAttribute('open', ''); }
      var show = function () { d.classList.add('is-open'); };
      requestAnimationFrame(function () { requestAnimationFrame(show); });
      setTimeout(show, 80);
      var btn = this.querySelector('[data-filters-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
    closeFilters(immediate) {
      var d = this.dialog;
      if (!d || !d.open) return;
      d.classList.remove('is-open');
      var btn = this.querySelector('[data-filters-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      var done = function () { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); };
      if (immediate || MQ_REDUCED.matches) done();
      else setTimeout(done, CLOSE_MS);
    }
  }

  customElements.define('jn-collection', JnCollection);
})();

/* 2026-09-23 集合描述展开/收起（栅格上方那块）。事件委托：Section Rendering 换掉 DOM 后照常可用。 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-collection-desc-toggle]');
  if (!btn) return;
  var box = btn.closest('[data-collection-desc]');
  var open = !box.classList.contains('is-open');
  box.classList.toggle('is-open', open);
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  var more = btn.querySelector('[data-label-more]'), less = btn.querySelector('[data-label-less]');
  if (more) more.hidden = open;
  if (less) less.hidden = !open;
});
